import { getEnv } from '../utils/environment';
import { simpleFetch } from './customFetch';

const getBillingInformation = (): Promise<any> =>
  simpleFetch({
    uri: '',
    options: {},
    baseUrl: getEnv().getBillingEndpoint,
  });

const updateBillingInformation = (data = {}): Promise<any> =>
  simpleFetch({
    uri: '',
    options: { method: 'PUT', body: JSON.stringify(data) },
    baseUrl: getEnv().updateBillingEndpoint,
  });

export { getBillingInformation, updateBillingInformation };
